// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"KbaseGroup_wrapper__3idk6","wrapperGrid":"KbaseGroup_wrapperGrid__2kW1D","list":"KbaseGroup_list__3vQOY"};